export const scrollToTop = () => {
  window.scroll({ top: 0, left: 0, behavior: 'smooth' })
}

export const scrollToBottom = () => {
  window.scroll({
    top: document.body.scrollHeight,
    left: 0,
    behavior: 'smooth',
  })
}
